<template>
  <section v-if="homeData" class="top-header container py-4 d-md-flex d-none justify-content-between align-items-baseline">
    <div class="d-flex align-items-baseline">
      <div class="logo-header ml-4"><img :src="'http://api.infinity-align.com/storage/'+homeData.settings.site_logo" :alt="homeData.settings.site_title"></div>
      <Navbar :data="homeData.menus.header"></Navbar>
    </div>

    <section>
      <!-- <div>
        <button class="sign-in-btn btn-hover-bulgy">
          <span class="text-color-theme ml-2 fontsize-mini">ورود به حساب کاربری</span>
          <svg class="icon" fill="#30504f"  width="20" height="20">
            <use href="@/assets/svgIcons/svgIcons.svg/#user-circle"></use>
          </svg>
        </button>
      </div> -->
      <div class="d-md-block d-none">
          <a target="_blank"   v-if="homeData.settings.whatsapp"  :href="`https://wa.me/${homeData.settings.whatsapp}`" class="bg-none ml-3">
            <svg class="icon" width="23" height="23" fill="#30504f">
             
        <path fill="white" id="Icon_awesome-whatsapp" data-name="Icon awesome-whatsapp" d="M15.739,4.94A9.176,9.176,0,0,0,1.3,16.01L0,20.762l4.863-1.277A9.145,9.145,0,0,0,9.248,20.6h0a9.262,9.262,0,0,0,9.26-9.173A9.209,9.209,0,0,0,15.739,4.94ZM9.252,19.055a7.611,7.611,0,0,1-3.884-1.062l-.277-.165-2.884.756.769-2.814-.182-.289a7.639,7.639,0,1,1,14.169-4.054,7.71,7.71,0,0,1-7.711,7.628Zm4.182-5.711c-.227-.116-1.355-.669-1.566-.744s-.364-.116-.517.116-.591.744-.727.9-.269.174-.5.058a6.239,6.239,0,0,1-3.12-2.727c-.236-.4.236-.376.674-1.252a.425.425,0,0,0-.021-.4c-.058-.116-.517-1.244-.707-1.7s-.376-.384-.517-.393S6.153,7.192,6,7.192a.849.849,0,0,0-.612.285,2.576,2.576,0,0,0-.8,1.913,4.49,4.49,0,0,0,.934,2.372,10.243,10.243,0,0,0,3.917,3.463,4.485,4.485,0,0,0,2.752.574,2.348,2.348,0,0,0,1.545-1.091,1.917,1.917,0,0,0,.132-1.091C13.814,13.514,13.661,13.456,13.433,13.345Z" transform="translate(0 -2.25)"/>
            </svg>
          </a>
          <a target="_blank"  v-if="homeData.settings.telegram"  :href="homeData.settings.telegram"  class="bg-none ml-3">
            <svg class="icon" width="23" height="23" fill="#30504f" viewBox="0 0 29.416 26.483">
              <path fill="white" id="Icon_awesome-telegram" data-name="Icon awesome-telegram" d="M14.708.562C6.583.562,0,6.489,0,13.8S6.583,27.045,14.708,27.045,29.416,21.119,29.416,13.8,22.833.562,14.708.562Zm7.223,9.071L19.517,19.875c-.178.726-.658.9-1.328.561L14.512,18l-1.773,1.538a.966.966,0,0,1-.741.326l.261-3.369,6.814-5.542c.3-.235-.065-.368-.457-.133l-8.421,4.773-3.629-1.02c-.789-.224-.807-.71.166-1.052l14.18-4.923S22.145,8.737,21.931,9.634Z" transform="translate(0 -0.563)"/>
            </svg>
          </a>
          <a target="_blank" v-if="homeData.settings.facebook"  :href="homeData.settings.facebook" class="bg-none ml-3">
            <svg class="icon" width="20" height="20" viewBox="0 0 23.979 23.979">
        <path id="Icon_awesome-facebook-square" fill="white" storke="white" data-name="Icon awesome-facebook-square" d="M21.41,2.25H2.569A2.569,2.569,0,0,0,0,4.819V23.66a2.569,2.569,0,0,0,2.569,2.569H9.916V18.077H6.544V14.24H9.916V11.315c0-3.327,1.98-5.164,5.014-5.164A20.429,20.429,0,0,1,17.9,6.41V9.675H16.227a1.919,1.919,0,0,0-2.164,2.073V14.24h3.681l-.589,3.837H14.064v8.152H21.41a2.569,2.569,0,0,0,2.569-2.569V4.819A2.569,2.569,0,0,0,21.41,2.25Z" transform="translate(0 -2.25)"/>
              
            </svg>
          </a>
          <a target="_blank" v-if="homeData.settings.instagram"  :href="homeData.settings.instagram"  class="bg-none ml-3">
            <svg class="icon" width="20" height="20" fill="#30504f"  viewBox="0 0 18.51 18.506">
              <path fill="white" id="Icon_awesome-instagram" data-name="Icon awesome-instagram" d="M9.252,6.746A4.745,4.745,0,1,0,14,11.491,4.737,4.737,0,0,0,9.252,6.746Zm0,7.829a3.085,3.085,0,1,1,3.085-3.085A3.09,3.09,0,0,1,9.252,14.575ZM15.3,6.552A1.107,1.107,0,1,1,14.19,5.445,1.1,1.1,0,0,1,15.3,6.552ZM18.44,7.675A5.477,5.477,0,0,0,16.945,3.8,5.513,5.513,0,0,0,13.067,2.3c-1.528-.087-6.107-.087-7.635,0A5.5,5.5,0,0,0,1.555,3.793,5.5,5.5,0,0,0,.06,7.671c-.087,1.528-.087,6.107,0,7.635a5.477,5.477,0,0,0,1.495,3.877,5.52,5.52,0,0,0,3.877,1.495c1.528.087,6.107.087,7.635,0a5.477,5.477,0,0,0,3.877-1.495,5.513,5.513,0,0,0,1.495-3.877c.087-1.528.087-6.1,0-7.631Zm-1.974,9.27A3.123,3.123,0,0,1,14.707,18.7c-1.218.483-4.109.372-5.455.372S5.011,19.184,3.8,18.7a3.123,3.123,0,0,1-1.759-1.759c-.483-1.218-.372-4.109-.372-5.455s-.107-4.241.372-5.455A3.123,3.123,0,0,1,3.8,4.277C5.015,3.793,7.906,3.9,9.252,3.9s4.241-.107,5.455.372a3.123,3.123,0,0,1,1.759,1.759c.483,1.218.372,4.109.372,5.455S16.949,15.731,16.466,16.945Z" transform="translate(0.005 -2.238)"/>
            </svg>
          </a>
        </div>
    </section>
  </section>

</template>

<script>
import Navbar from "./Navbar";
export default {
  name: "TopHeader",
  components:{
    Navbar
  },
  computed:{
    homeData(){
      return this.$root.homeData;
    }
  }
}
</script>

<style scoped>
.logo-header{
  width: 113px;
}
.logo-header img{
  width: 100%;
  height: auto;
}
.sign-in-btn{
  border:1px solid var(--color-theme);
  border-radius: 10px;
  background: none;
  padding: 7px 16px;
}

@media screen and (max-width: 991px){
  .logo-header{
    width: 80px;
  }
}
</style>